module.exports = __webpack_public_path__ + "static/media/CSS.219bb821.jpg";